// src/components/Products/ProductSection.js
import React, { useEffect } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { BsArrowRight } from 'react-icons/bs';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css'; // Import carousel styles
import AOS from 'aos';
import 'aos/dist/aos.css';
import './Products.css';
import img1 from '../../assets/Products/img1.png';
import img2 from '../../assets/Products/img2.png';
import img3 from '../../assets/Products/img3.png';
import img4 from '../../assets/Products/img4.png';


const ProductSection = () => {
  
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  // Responsive breakpoints for the carousel
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4 // Show 4 items on desktop as per design
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1 // Show 1 item on mobile
    }
  };

  // Product Data
  const products = [
    {
      id: 1,
      title: "Precision Stamped Components",
      img: img1
    },
    {
      id: 2,
      title: "Auto & Engine Components",
      img: img2
    },
    {
      id: 3,
      title: "CNC Machined Parts",
      img: img3
    },
    {
      id: 4,
      title: "Assembly & Sub-Assemblies",
      img: img4
    },
    {
      id: 5,
      title: "Electrical Connectors",
      img: img2
    }
  ];

  return (
    <section className="product-section" id="products">
      <Container>
        {/* Header Row */}
        <Row className="align-items-end mb-5">
          <Col md={8} data-aos="fade-right">
            <span className="section-label-sm">Our Products</span>
            <h2 className="section-title-lg">Product Categories</h2>
          </Col>
          
          <Col md={4} className="text-md-end text-start mt-3 mt-md-0" data-aos="fade-left">
            <Button className="btn-orange-pill">
              View All Products
            </Button>
          </Col>
        </Row>

        {/* Carousel Row */}
        <div data-aos="fade-up" data-aos-delay="200">
          <Carousel 
            responsive={responsive}
            infinite={true}
            autoPlay={true}
            autoPlaySpeed={3000}
            keyBoardControl={true}
            customTransition="transform 500ms ease-in-out"
            transitionDuration={500}
            containerClass="carousel-container"
            removeArrowOnDeviceType={["tablet", "mobile"]}
            itemClass="carousel-item-padding-40-px"
          >
            {products.map((product) => (
              <div key={product.id} className="product-card">
                <img src={product.img} alt={product.title} className="product-img" />
                
                <div className="card-overlay">
                  <div className="card-content">
                    <h3 className="product-name">{product.title}</h3>
                    <div className="card-arrow">
                      <BsArrowRight />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Carousel>
        </div>

      </Container>
    </section>
  );
};

export default ProductSection;